import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import { Stack, Text } from "@mantine/core";
import type React from "react";
import type { FC } from "react";
import { Link } from "react-router";

export interface ICardClassNames {
  root?: string;
  title?: string;
  text?: string;
}

export interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  text: string;
  button?: React.ReactNode;
  withBackground?: boolean;
  classNames?: ICardClassNames;
  to?: string;
}

const InfoCard: FC<InfoCardProps> = ({
  icon,
  text,
  title,
  button,
  withBackground = true,
  classNames,
  to,
}) => {
  const card = (
    <Stack
      align="center"
      className={`hover-scale !w-full xs:w-80 rounded-3xl px-8 py-7 xs:py-10 lg:w-96 lg:px-12 lg:py-8 ${
        withBackground && "bg-primary-darker"
      } ${classNames?.root ?? ""}`}
    >
      {icon}
      <Stack align="center" className="pt-4" justify="center">
        <SSHeadline
          props={{
            title: {
              className: classNames?.title,
              ta: "center",
              fz: 18,
              order: 3,
            },
          }}
        >
          <SSWhiteText>{title.toUpperCase()}</SSWhiteText>
        </SSHeadline>
        <Text
          className={`font-inter font-light text-primary-dark-text tracking-wide ${classNames?.text ?? ""}`}
          size="sm"
          ta="center"
        >
          {text}
        </Text>
        {button}
      </Stack>
    </Stack>
  );
  if (to) {
    return (
      <Link to={to} target="_blank" className="no-underline">
        {card}
      </Link>
    );
  }

  return card;
};

export default InfoCard;
